import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthorizedRoute } from 'components/authorized-route';
import Login from 'pages/login/index.jsx';

import ApplicationManagement from 'pages/application-management/index';
import DashboardPage from 'pages/dashboard';

import ContentReview from 'pages/guardrail/content-review';
import ContentDetail from 'pages/guardrail/content-detail';

import TextBase from 'pages/resource/text-base/';
import ImageBase from 'pages/resource/image-base/';

import User from 'pages/permission/user';
import Role from 'pages/permission/role';
import RoleEdit from 'pages/permission/role/role-view';
import NotFoundPage from 'pages/404/index';

import Protection from 'pages/protection';
import Imprint from 'pages/imprint';
import Terms from 'pages/terms';
import AppLayout from 'components/layout';
import * as Permissions from '../constants/permissions';

export const routes = [
	{
		path: '/login',
		element: <Login />,
	},
	{
		path: '/',
		element: <AppLayout />,
		children: [
			{ index: true, element: <Navigate to="application/application-management" /> },
			{
				path: 'application',
				children: [
					{
						path: 'application-management',
						element: (
							<AuthorizedRoute
								element={<ApplicationManagement />}
								requiredPermissions={[Permissions.Application_LIST]}
							/>
						),
					},
				],
			},
			{
				path: 'resource',
				children: [
					{
						path: 'knowledge-base',
						element: <AuthorizedRoute element={<TextBase />} requiredPermissions={[Permissions.KnowledgeBase_LIST]} />,
					},
					{
						path: 'image-base',
						element: <AuthorizedRoute element={<ImageBase />} requiredPermissions={[Permissions.Image_LIST]} />,
					},
				],
			},
			{
				path: 'guardrail',
				children: [
					{
						path: 'content-review',
						element: (
							<AuthorizedRoute element={<ContentReview />} requiredPermissions={[Permissions.ContentReview_LIST]} />
						),
					},
					{
						path: 'content-review/:sessionId',
						element: (
							<AuthorizedRoute element={<ContentDetail />} requiredPermissions={[Permissions.ContentReview_DETAIL]} />
						),
					},
				],
			},
			{
				path: 'dashboard',
				element: <AuthorizedRoute element={<DashboardPage requiredPermissions={[Permissions.Dashboard]} />} />,
			},
			{
				path: 'permission',
				children: [
					{
						path: 'user',
						element: <AuthorizedRoute element={<User />} requiredPermissions={[Permissions.Users_LIST]} />,
					},
					{
						path: 'role',
						element: <AuthorizedRoute element={<Role />} requiredPermissions={[Permissions.Roles_LIST]} />,
					},
					{
						path: 'role/add',
						element: <AuthorizedRoute element={<RoleEdit />} requiredPermissions={[Permissions.Roles_ADD]} />,
					},
					{
						path: 'role/:roleId',
						element: <AuthorizedRoute element={<RoleEdit />} requiredPermissions={[Permissions.Roles_EDIT]} />,
					},
				],
			},
			{
				path: '*',
				element: <NotFoundPage />,
			},
		],
	},
	{
		path: '/protection',
		element: <Protection />,
	},
	{
		path: '/imprint',
		element: <Imprint />,
	},
	{
		path: '/terms',
		element: <Terms />,
	},
];
